import { render, staticRenderFns } from "./ContratContent.vue?vue&type=template&id=6b52ea94&scoped=true&"
import script from "./ContratContent.vue?vue&type=script&lang=js&"
export * from "./ContratContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52ea94",
  null
  
)

export default component.exports